module.exports = __webpack_public_path__ + "media/images/product-banners/dc-modeller-f96991a94326d499f4003e5669d6b930.svg";